import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function getAllWarehouseData(salesOrg: any) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/admin/warehouseData`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveWarehouseLocation(
  salesOrg:  string,
  deliveryPlant: string,
  latitude: string,
  longitude: string,
  timezone: string
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      clientId: "100",
      salesOrg,
      deliveryPlant,
      latitude,
      longitude,
      timezone
    },
    url: `${BASE_URL}/api/admin/warehouseData/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deleteAlertMessage(salesOrg:string,guid:string) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data: {
      guid
    },
    url: `${BASE_URL}/api/admin/alertMessagesData/delete`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

